export default __webpack_public_path__ + "static/media/register.8009f606.png";